import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import axios from "axios";
import LoadingImage from "../../../images/loading.svg"
import { Container, Row, Col, Form, Button } from "react-bootstrap"
import { getFormData, updateFormData } from "../../forms/api/Api"
import * as qs from "query-string"
import $ from "jquery"

import HomeVisit from "../../forms/home-visit-quick"
import { CONTACT_PAGE_URL, FIND_A_PROPERTY_PAGE_URL } from "../../common/site/constants"

const HomeTrackResult = (props) => {

  const [property_details, setPropertyData] = useState('');
  const [loading, setloading] = useState(true);
  const formvalues = [];

  formvalues['address'] = props.address;
  formvalues['postcode'] = props.postcode;
  formvalues['bedroom'] = props.bedroom;
  formvalues['ptype'] = props.ptype;
  formvalues['name'] = props.name;
  formvalues['email'] = props.email;

  const updateForm = (resultVal, formvalues) =>{ 
    if((resultVal?.propertyValuation || resultVal?.rentalValuation) && props.formId){
      getFormData(props.formId).then(async apiRes => { 
        let extraResponse = {...apiRes['extra']}
        extraResponse['instant_valuation'] = {
          max_valuation : resultVal?.propertyValuation?.upperValue,
          avg_valuation : resultVal?.propertyValuation?.value,
          min_valuation : resultVal?.propertyValuation?.lowerValue,
          max_rent : resultVal?.rentalValuation?.monthlyRentalUpperValue,
          avg_rent :  resultVal?.rentalValuation?.monthlyRentalValue,
          min_rent :  resultVal?.rentalValuation?.monthlyRentalLowerValue,
        }
        extraResponse['instant_max_valuation'] = resultVal?.propertyValuation?.upperValue;
        extraResponse['instant_avg_valuation'] = resultVal?.propertyValuation?.value;
        extraResponse['instant_min_valuation'] = resultVal?.propertyValuation?.lowerValue;
        extraResponse['instant_max_rent_valuation'] = resultVal?.rentalValuation?.monthlyRentalUpperValue;
        extraResponse['instant_avg_rent_valuation'] = resultVal?.rentalValuation?.monthlyRentalValue;
        extraResponse['instant_min_rent_valuation'] = resultVal?.rentalValuation?.monthlyRentalLowerValue;
        extraResponse['hometrack_status'] = true;
        extraResponse['hometrack_message'] = "Hometrack Sucess"
        apiRes['extra'] = extraResponse; 
        formvalues['g-recaptcha-response'] = extraResponse['g-recaptcha-response'];
        window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/functions`, {
          method: `POST`,
          mode: "no-cors",
          headers: {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: qs.stringify(formvalues),
        })
        updateFormData(apiRes).then(async upRes => { });
        
      });
    }else if (resultVal?.error){
      let message = resultVal.error?.Message || resultVal.error?.[0]?.value || 'Internal Server Error on Home Track Request';
      getFormData(props.formId).then(async apiRes => { 
        let extraResponse = {...apiRes['extra']}
        extraResponse['hometrack_status'] = false
        extraResponse['hometrack_message'] = message
       
        apiRes['extra'] = extraResponse; 
        updateFormData(apiRes).then(async upRes => { });
      });
    } 
  }

  useEffect(async () => {
    const home = await window.fetch(`${process.env.GATSBY_STRAPI_SRC}/hometrack`, {
      method: `POST`,
      body: JSON.stringify({ address: props.address, postcode: props.postcode, bedroom: props.bedroom, ptype: props.ptype }),
    }) 
    setPropertyData(await home.json());
     
   

    setloading(false)
    $("#track-result-home").hide()
    $("#track-result-head").show()
  }, []);

  if (loading) return (
    <div className="valuation-form home-track-results">
      <div className="form-wrapper loading-img">
        <img src={LoadingImage} alt="" />
      </div>
      <div className="home-visit">
        <h2>Book a Home Visit Valuation</h2>
        <h3>Simply tell us the type of valuation you need and we’ll be in touch.</h3>
        <div className="btn-wrapper">
          <Link href="#" className="btn btn-primary">I’d like to Sell</Link>
          <Link href="#" className="btn">I’d like to Let</Link>

        </div>
      </div>
    </div>
  );

  if(!loading && property_details) {
    if(property_details?.error){
      updateForm(property_details, null);
    }else{
    formvalues['maxprice'] = property_details?.propertyValuation?.upperValue.toLocaleString();
    formvalues['rentmaxprice'] = property_details?.rentalValuation?.monthlyRentalUpperValue.toLocaleString();
    formvalues['email_subject_user'] = "Your Instant Valuation"
    formvalues['email_temp_user'] = "instant_valuation_user"
    updateForm(property_details, formvalues); 
    }
  }      

  return (
    <React.Fragment>
      <div className="valuation-form home-track-results" id="track-results">
        {property_details.propertyValuation ?
          <div className="form-wrapper">
            <div className="info-wrapper">
              <div className="sales-info">
                <Link href="#" className="icons">
                  <i className="icon-sale"></i>
                </Link>
                <h2>Sales Valuation</h2>
                <div className="range">
                  <div className="limit">Maximum Valuation</div>
                  <div className="price">£{property_details?.propertyValuation?.upperValue.toLocaleString()}</div>
                </div>
                <div className="range">
                  <div className="limit one">Average Valuation</div>
                  <div className="price">£{property_details?.propertyValuation?.value.toLocaleString()}</div>
                </div>
                <div className="range last">
                  <div className="limit one">Minimum Valuation</div>
                  <div className="price">£{property_details?.propertyValuation?.lowerValue.toLocaleString()}</div>
                </div>
              </div>
              <div className="rental-info">
                <Link href="#" className="icons">
                  <i className="icon-rent"></i>
                </Link>
                <h2>Rental Valuation</h2>
                <div className="range">
                  <div className="limit">Maximum Valuation</div>
                  <div className="price">£{property_details?.rentalValuation?.monthlyRentalUpperValue.toLocaleString()} p/m</div>
                </div>
                <div className="range">
                  <div className="limit one">Average Valuation</div>
                  <div className="price">£{property_details?.rentalValuation?.monthlyRentalValue.toLocaleString()} p/m</div>
                </div>
                <div className="range last">
                  <div className="limit one">Minimum Valuation</div>
                  <div className="price">£{property_details?.rentalValuation?.monthlyRentalLowerValue.toLocaleString()} p/m</div>
                </div>
              </div>
            </div>
          </div> :
          <div className="form-wrapper no-hometrack-results-found">
            <div className="info-wrapper">
              <p>Sorry, we were unable to offer an instant valuation for this property but you can <Link to="/get-in-touch/">book an in-person valuation</Link> with your local team to get an accurate appraisal.</p>
            </div>
          </div>
        }

        <div className="home-visit">
          <h2>Book a Home Visit Valuation</h2>
          <h3>Simply tell us the type of valuation you need and we’ll be in touch.</h3>
          <div className="btn-wrapper row" id="home-visit-cta-quick">
            <div className="col-md-6 mb-md-0 mb-3">
              {/* <HomeVisit {...props} id="5" title="I’d like to Sell" /> */}
              <Link href="/sell-your-property/property-valuation" className="btn btn-primary">I’d like to Sell</Link>
            </div>
            <div className="col-md-6">
              {/* <HomeVisit {...props} id="14" title="I’d like to Let" /> */}
              <Link href="/sell-your-property/property-valuation" className="btn btn-primary">I’d like to Let</Link>
            </div>
          </div>

          <div className="home-load-quick" id="home-load-quick">
            Please wait
          </div>
        </div>
      </div>
      <div id="track-result-home">
        <div className="instant-form home-visit-success-results" id="home-form">
          <Container>
            <Row>
              <Col lg={10}>
                <div className="head">
                  <span class="sm-text">Home visit valuation</span>
                  <h1>Thank You</h1>
                  <div className="back">Your request has been sent to our team and we will contact you shortly to arrange an appointment and explain the process in more detail.
                  </div>
                </div>
              </Col>
              <Col lg={8} className="main-banner">
                <div className="btn-wrap">
                  <Link to={CONTACT_PAGE_URL.alias} class="btn btn-secondary">
                    <span>For any enquiries</span>Contact us
                  </Link>
                  <Link to={FIND_A_PROPERTY_PAGE_URL.alias} class="btn">
                    <span>Buying or renting?</span>Find a property
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default HomeTrackResult